export const useMapStyle = () => {
  //const themeOptions = useConcreteThemeOptions();
  //const isDarkMode = themeOptions.name === "dark";
  return "mapbox://styles/habryka/cilory317001r9mkmkcnvp2ra";
  // See also: mapbox://styles/mapbox/dark-v11 (used by EA Forum in dark mode)
}
